export const readJson = async (url) => {
    const response = await fetch(url);
    const contentType = response.headers.get('Content-Type');
    if (!response.ok || contentType.indexOf('application/json') < 0) {
        return null;
    }
    return await response.json();
};
